import { BehaviorSubject, filter, tap } from 'rxjs';
import Scroll from './Scroll';
const NO_COMPONENT = null;
const overlayEl = document.getElementById("js-overlay");
const overlayState$ = new BehaviorSubject(NO_COMPONENT);
export const whenOverlayShown$ = overlayState$.pipe(filter(state => state !== NO_COMPONENT));
export const whenNotShownInOverlay$ = (component) => overlayState$.pipe(filter(state => state !== component));
if (overlayEl) {
    overlayEl.addEventListener('click', () => {
        hideOverlay();
    });
    overlayState$
        .pipe(tap(state => console.log("overlay state", state)))
        .subscribe((state) => {
        if (state === NO_COMPONENT) {
            overlayEl.classList.remove('is-active');
            Scroll.unlock();
        }
        else {
            overlayEl.classList.add('is-active');
            Scroll.lock();
        }
    });
}
export function hideOverlay() {
    if (overlayState$.getValue() !== NO_COMPONENT) {
        overlayState$.next(NO_COMPONENT);
    }
}
export function showOverlay(content) {
    overlayState$.next(content);
}
export function isOverlayShown() {
    return overlayState$.getValue() !== NO_COMPONENT;
}
